var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRoundedDarkCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.624,
    height: 17.607,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.999 11)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.407,1.373c0-.313-.009-.608,0-.9A.434.434,0,0,1,4.872.008a.431.431,0,0,1,.464.457c0,.295,0,.59,0,.9h6.95c0-.3,0-.6,0-.9a.405.405,0,0,1,.277-.422.432.432,0,0,1,.519.1.823.823,0,0,1,.133.416c.02.264.006.532.006.813h3.8c.427,0,.6.176.6.608q0,7.512,0,15.023c0,.428-.177.6-.607.6H.6c-.429,0-.6-.176-.6-.605Q0,9.49,0,1.978c0-.43.175-.605.6-.605h3.8ZM16.663,16.653V2.328H13.215c0,.31.011.613,0,.915a.463.463,0,0,1-.925-.038c0-.288,0-.575,0-.873H5.337c0,.315,0,.618,0,.92a.414.414,0,0,1-.4.427.434.434,0,0,1-.521-.44c-.014-.3,0-.6,0-.9H.962V16.653Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.164,96.444H34.783c-.422,0-.646-.277-.525-.636a.434.434,0,0,1,.384-.3,1.216,1.216,0,0,1,.173,0c4.235,0,5.466,0,9.7,0,.239,0,.451.036.551.289a.463.463,0,0,1-.409.656c-.072.006-.145,0-.217,0H38.164",
    transform: "translate(-30.854 -89.956)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRoundedDarkCalendar);
export default __webpack_public_path__ + "static/media/icon_rounded_dark_calendar.539649696e26fd3e3ea3f8674afca485.svg";
export { ForwardRef as ReactComponent };